import React, {Component} from 'react';
import {FormInline, Button, Dropdown, DropdownToggle, DropdownMenu} from 'mdbreact';

export default class Search extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false,
        };
    }
    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    render() {
        return (
           <Dropdown isopen = {this.state.dropdownOpen.toString()} toggle = { this.toggle }>
                <DropdownToggle color="link" style={{padding: 4, margin:2}}>
                    <i className="flaticon-search-1 "></i>
                </DropdownToggle>
                <DropdownMenu className="searchBox">
                    <FormInline>
                        <input type="text" id="searchInput" name="searchInput" className="form-control" placeholder="جستجو..."/>

                        {/*<Input label="جستجو..."  type="text" className="form-control"/>*/}
                        <Button   color="deep-orange" className='search-btn'>  <i className="flaticon-search-1 "></i></Button>
                    </FormInline>
                </DropdownMenu>
            </Dropdown>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/header/Search.js